import { getBaseUrl, request, sessionFetch } from './http';

function queryString(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') search.set(key, value);
  });
  const text = search.toString();
  return text ? `?${text}` : '';
}

async function fetchAirPdf(path) {
  const root = String(getBaseUrl() || '').replace(/\/+$/, '');
  const response = await sessionFetch(`${root}/api/air-permitting/${path}`);
  if (!response.ok) {
    let message = 'The PDF could not be created.';
    try {
      const body = await response.json();
      if (body?.message) message = body.message;
    } catch {
      // The body was not JSON.
    }
    throw new Error(message);
  }
  return response.blob();
}

async function downloadAirPdf(path, filename) {
  const blob = await fetchAirPdf(path);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export const airPermittingApi = {
  getAirCompanies: () => request('/air-permitting/companies'),
  getAirGlycolPumps: (params) => request(`/air-permitting/glycol-pumps${queryString(params)}`),
  createAirGlycolPump: (data) => request('/air-permitting/glycol-pumps', { method: 'POST', body: JSON.stringify(data) }),
  updateAirGlycolPump: (id, data) => request(`/air-permitting/glycol-pumps/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteAirGlycolPump: (id) => request(`/air-permitting/glycol-pumps/${id}`, { method: 'DELETE' }),

  getAirFlares: (params) => request(`/air-permitting/flares${queryString(params)}`),
  createAirFlare: (data) => request('/air-permitting/flares', { method: 'POST', body: JSON.stringify(data) }),
  updateAirFlare: (id, data) => request(`/air-permitting/flares/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteAirFlare: (id) => request(`/air-permitting/flares/${id}`, { method: 'DELETE' }),

  getAirGlycolLogs: (params) => request(`/air-permitting/glycol${queryString(params)}`),
  getAirGlycolLog: (id) => request(`/air-permitting/glycol/${id}`),
  createAirGlycolLog: (data) => request('/air-permitting/glycol', { method: 'POST', body: JSON.stringify(data) }),
  updateAirGlycolLog: (id, data) => request(`/air-permitting/glycol/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteAirGlycolLog: (id) => request(`/air-permitting/glycol/${id}`, { method: 'DELETE' }),
  downloadAirGlycolPdf: (record) => downloadAirPdf(`glycol/${record.id}/pdf`, `daily-glycol-log-${record.logDate || record.id}.pdf`),

  getAirOpacityLogs: (params) => request(`/air-permitting/opacity${queryString(params)}`),
  getAirOpacityLog: (id) => request(`/air-permitting/opacity/${id}`),
  createAirOpacityLog: (data) => request('/air-permitting/opacity', { method: 'POST', body: JSON.stringify(data) }),
  updateAirOpacityLog: (id, data) => request(`/air-permitting/opacity/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteAirOpacityLog: (id) => request(`/air-permitting/opacity/${id}`, { method: 'DELETE' }),
  downloadAirOpacityPdf: (record) => downloadAirPdf(`opacity/${record.id}/pdf`, `opacity-monitoring-${record.logDate || record.id}.pdf`),

  getAirFlareDays: (params) => request(`/air-permitting/flare-days${queryString(params)}`),
  getAirFlareDay: (id) => request(`/air-permitting/flare-days/${id}`),
  getAirFlareLogStart: (params) => request(`/air-permitting/flare-days/start${queryString(params)}`),
  createAirFlareDay: (data) => request('/air-permitting/flare-days', { method: 'POST', body: JSON.stringify(data) }),
  updateAirFlareDay: (id, data) => request(`/air-permitting/flare-days/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteAirFlareDay: (id) => request(`/air-permitting/flare-days/${id}`, { method: 'DELETE' }),
  fetchAirFlarePdf: (record) => fetchAirPdf(`flare-days/${record.id}/pdf`),
  downloadAirFlarePdf: (record) => downloadAirPdf(`flare-days/${record.id}/pdf`, `daily-flare-log-${record.logDate || record.id}.pdf`),
  ensureAirFlareMonth: (data) => request('/air-permitting/flare-months/ensure', { method: 'POST', body: JSON.stringify(data) }),
  updateAirFlareMonth: (id, data) => request(`/air-permitting/flare-months/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  getAirFlarePreview: (params) => request(`/air-permitting/flare-preview${queryString(params)}`)
};
